export interface Top5BucketItem {
  name: string;
  value: number;
}

export const top5BucketsMock: Top5BucketItem[] = [
  { name: "arkiv", value: 15.55 },
  { name: "mtjenester", value: 14.32 },
  { name: "nasuni", value: 9.84 },
  { name: "eh-backup", value: 9.03 },
  { name: "storage3volume01", value: 1.43 },
];
